var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgI(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 35,
    viewBox: "0 0 8 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_70)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.51562 35H0.484375V0.875H7.51562V35Z",
    fill: "url(#paint0_linear_6_70)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_70",
    x1: 4,
    y1: 0.875,
    x2: 4,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3477DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A9AE3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_70"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI);
export default __webpack_public_path__ + "static/media/I.e0a0afd4ab099a7d9ff27f7f1ad97c62.svg";
export { ForwardRef as ReactComponent };